// AI生视频
const jmRoutes = Array.from({ length: 16 }, (_, i) => ({
  path: `AIDigitalHuman/jm/index${i + 1}`,
  name: `AIDigitalHuman/jm/Index${i + 1}`,
  component: () => import(`@/views/smartLife/AIDigitalHuman/jm/index${i + 1}.vue`)
}))




import AIDigitalHumanIndex from '@/views/smartLife/AIDigitalHuman/index'



export default {
  path: '/smartLife',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'AIDigitalHuman/index',
        name: 'AIDigitalHumanIndex',
        component: AIDigitalHumanIndex
      },
    // AI数字人，开始
    ...jmRoutes,
    // AI数字人，结束


  ],
};
